/**
 *
 * Calculates the pages to display in the paginator for page to page navigation
 * instead of displaying all pages as they can be a lot of pages.
 *
 */
export default function calculateThePagesToShowOnPagination(
  currentRefinement: number,
  nbPages: number,
) {
  if (nbPages <= 5) {
    return Array.from(Array(nbPages).keys()).map((i) => i + 1);
  }

  // first page is always shown
  const paginationPages = [1];

  // first ellipsis is shown when there is a gap between 1 and the next
  // displayed value
  if (currentRefinement - 3 > 1) {
    paginationPages.push(-1);
  }

  // display the second lowest page from the current page
  if (currentRefinement - 2 > 1) {
    paginationPages.push(currentRefinement - 2);
  }

  // display the first lowest page number from current page
  if (currentRefinement - 1 > 1) {
    paginationPages.push(currentRefinement - 1);
  }

  // display current page only if its not first or last page
  if (currentRefinement !== nbPages && currentRefinement !== 1) {
    paginationPages.push(currentRefinement);
  }

  // display first page from the current page
  if (currentRefinement + 1 < nbPages) {
    paginationPages.push(currentRefinement + 1);
  }

  // display the second page from the current page
  if (currentRefinement + 2 < nbPages) {
    paginationPages.push(currentRefinement + 2);
  }

  // display an ellipsis if there a gap between second page from current page
  // and last page
  if (currentRefinement + 3 < nbPages) {
    paginationPages.push(-2);
  }

  // last page is always created
  paginationPages.push(nbPages);

  return paginationPages;
}
